import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_post_ext_RowClass} from '../../../dbschema/bl_cms_post_ext.model';
import {bl_cms_post_hdr_RowClass} from '../../../dbschema/bl_cms_post_hdr.model';
import { bl_cms_post_image_RowClass } from '../../../dbschema/bl_cms_post_image.model';

export class CmsPostContainerModel extends BaseContainerModel {
  bl_cms_post_hdr: bl_cms_post_hdr_RowClass = new bl_cms_post_hdr_RowClass();
  bl_cms_post_exts: bl_cms_post_ext_RowClass[] = [];
  bl_cms_post_images: bl_cms_post_image_RowClass[] = [];
}
